import { FormBase } from "../../util/form-base-form";

type PlaceholderRoot = ParentNode | Document | HTMLElement | null | undefined;

export interface ProductPlaceholderCardParts {
    header: HTMLElement;
    titleRow: HTMLElement;
    metaLine: HTMLElement;
    bodyLine: HTMLElement;
    footerLine: HTMLElement;
    footerLeft: HTMLElement;
    footerRight: HTMLElement;
}

class ProductPlaceholderAdsForm extends FormBase {
    public getPendingCards(root: PlaceholderRoot): HTMLElement[] {
        const cards = this.queryElements(root, "[data-product-placeholder-ad='1']", HTMLElement);
        return cards.filter((card) => card.dataset.productPlaceholderAdApplied !== "1");
    }

    public getCardParts(card: ParentNode): ProductPlaceholderCardParts | null {
        const header = this.queryElement(card, "[data-product-placeholder-part='header']", HTMLElement);
        const titleRow = this.queryElement(card, "[data-product-placeholder-part='title-row']", HTMLElement);
        const metaLine = this.queryElement(card, "[data-product-placeholder-part='meta']", HTMLElement);
        const bodyLine = this.queryElement(card, "[data-product-placeholder-part='body']", HTMLElement);
        const footerLine = this.queryElement(card, "[data-product-placeholder-part='footer']", HTMLElement);
        const footerLeft = this.queryElement(card, "[data-product-placeholder-part='footer-left']", HTMLElement);
        const footerRight = this.queryElement(card, "[data-product-placeholder-part='footer-right']", HTMLElement);

        if (!(header && titleRow && metaLine && bodyLine && footerLine && footerLeft && footerRight)) {
            return null;
        }

        return {
            header,
            titleRow,
            metaLine,
            bodyLine,
            footerLine,
            footerLeft,
            footerRight,
        };
    }

    public getFallbackImage(card: ParentNode): HTMLImageElement | null {
        return this.queryElement(card, "[data-product-placeholder-part='image']", HTMLImageElement);
    }

    public getImageBadges(header: ParentNode): HTMLElement | null {
        return this.queryElement(header, ".product-image-badges", HTMLElement);
    }
}

export const productPlaceholderAdsForm = new ProductPlaceholderAdsForm();
